export const DUPLICATE_RESPONSE_CODE = 'restricted_business_name';

export const COMPLETED_STATUS_CODE = 'complete';

export const REQUIRED_OUTPUT_VARIABLES = [
  {
    name: 'business_usecase',
    is_required: true,
    is_multiple: false,
  },
  {
    name: 'app_requirements',
    is_required: true,
    is_multiple: false,
  },
  {
    name: 'strategic_plan',
    is_required: true,
    is_multiple: false,
  },
];

export const MAX_RETRY_MS = 30000;

export const RETRY_INTERVAL = 100;

export const SAMPLE_IDEAS = (t: any) => [
  t(
    'I need to track customer health with a new customer success management application for my technology company'
  ),
  t('Build me a secure client portal for my financial services business'),
  t('Build me an application that automates patient treatment plans'),
  t('I need an automated member onboarding workflow for my fitness club'),
  t('Build me a medical device tracking system'),
  t('I need an onboarding workflow for new employees'),
  t('Build me a commission calculator for my insurance agency.'),
  t('I need a CRM with sales agentic workflow for my healthcare organization.'),
  t('Build me a secure client portal for my financial services business'),
  t('Build me a document management system for my legal firm'),
  t('Build me a commission calculator for my insurance agency'),
];
